import { Navigate } from "react-router-dom";
import { useToken } from "./tokenContext";
import LoadingSkeleton from "../components/loading";
import PropTypes from "prop-types";

const ProtectedRoute = ({ children, module, action }) => {
  const { token, hasPermission, loading } = useToken();

  if (loading) {
    return <LoadingSkeleton />;
  }

  if (!token) {
    return <Navigate to="/login" />;
  }

  if (!hasPermission(module, action)) {
    return <Navigate to="/semPermissao" />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node,
  module: PropTypes.string,
  action: PropTypes.string,
};

export default ProtectedRoute;
